import Wrapper from './theme-wrapper'

export const wrapRootElement = Wrapper
